// AUTO-GENERATED SQL Builder (V40 Final) for Resale
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class ResaleSql {
  private ast = new SqlAst('Resale', 'resale');
  public readonly main: any = {};

  public guid: SqlField;
  public resellerVendorId: SqlField;
  public offeringId: SqlField;
  public price: SqlField;
  public isEnabled: SqlField;
  public offeringPackageId: SqlField;
  public eventSessionId: SqlField;
  public offeringItemId: SqlField;
  public createdByUser: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public offeringItem: SqlNavHybrid;
  public offeringPackage: SqlNavHybrid;
  public resellerVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('resale', 'guid', '', 'id', 'resale_guid');
    this.resellerVendorId = new SqlField('resale', 'resellerVendorId', '', 'id', 'resale_resellerVendor');
    this.offeringId = new SqlField('resale', 'offeringId', 'offering', 'id', 'resale_offering');
    this.price = new SqlField('resale', 'price', '', 'id', 'resale_price');
    this.isEnabled = new SqlField('resale', 'isEnabled', '', 'id', 'resale_isEnabled');
    this.offeringPackageId = new SqlField('resale', 'offeringPackageId', 'offeringPackage', 'id', 'resale_offeringPackage');
    this.eventSessionId = new SqlField('resale', 'eventSessionId', 'eventSession', 'id', 'resale_eventSession');
    this.offeringItemId = new SqlField('resale', 'offeringItemId', 'offeringItem', 'id', 'resale_offeringItem');
    this.createdByUser = createNavHybrid('resale', 'resale_createdByUser', 'User');
    this.eventSession = createNavHybrid('resale', 'resale_eventSession', 'EventSession');
    this.offering = createNavHybrid('resale', 'resale_offering', 'Offering');
    this.offeringItem = createNavHybrid('resale', 'resale_offeringItem', 'OfferingItem');
    this.offeringPackage = createNavHybrid('resale', 'resale_offeringPackage', 'OfferingPackage');
    this.resellerVendor = createNavHybrid('resale', 'resale_resellerVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('resale', 'resale_updatedByUser', 'User');
    this.id = new SqlField('resale', 'id', '', 'id', 'resale_id');
    this.isDeleted = new SqlField('resale', 'isDeleted', '', 'id', 'resale_isDeleted');
    this.createdBy = new SqlField('resale', 'createdBy', '', 'id', 'resale_createdBy');
    this.createdDate = new SqlField('resale', 'createdDate', '', 'id', 'resale_createdDate');
    this.updatedBy = new SqlField('resale', 'updatedBy', '', 'id', 'resale_updatedBy');
    this.updatedDate = new SqlField('resale', 'updatedDate', '', 'id', 'resale_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:ResaleSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:ResaleSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:ResaleSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:ResaleSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:ResaleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:ResaleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:ResaleSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:ResaleSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:ResaleSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:ResaleSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
